export enum MediaTypeEnumerator {
  VIDEO = 1,
  IMAGE = 2,
  AUDIO = 3,
  EXTERNAL_LINK = 4,
}